import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { CustomizationModalProps } from './types';

type CustomizationModalEntryPointComponent = EntryPointComponent<
	{},
	{},
	CustomizationModalProps,
	{}
>;

export const customizationModalEntryPoint: EntryPoint<CustomizationModalEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<CustomizationModalEntryPointComponent>(
			/* webpackChunkName: "async-navigation-global-side-navigation-customization-modal" */ './index',
			{
				moduleId: 'navigation.global-side-navigation.customization-modal',
			},
		),
		getPreloadProps: () => ({}),
	});
